import { Component, OnInit, Inject } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { MatDialog as MatDialog, MatDialogRef as MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.css']
})
export class AlertDialogComponent implements OnInit {
 message: any;
 title: string;
 closeButton: string= "close";
 errSta:any;
 flag:any=0;
  constructor(
    public dialogRef: MatDialogRef<AlertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }
  ngOnInit() {
  }
  close(){
    this.dialogRef.close();
  }
  isArray(anInput){
    return Array.isArray(anInput);
  }
  isObject(anInput){
    return typeof anInput === 'object';
  }
}
